import { render, staticRenderFns } from "./CPLoader.vue?vue&type=template&id=70b9c633&scoped=true&"
import script from "./CPLoader.vue?vue&type=script&lang=ts&"
export * from "./CPLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CPLoader.vue?vue&type=style&index=0&id=70b9c633&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9c633",
  null
  
)

export default component.exports